import request from '#api/axios';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { HEALTH_INFO_TYPE } from '#pages/Community-refactor/write/constant';
import { IGetDiseaseKinds } from '#types/diseaseKinds';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const getDiseaseKinds = async () => {
  const res = await request<IGetDiseaseKinds>({
    method: 'get',
    url: '/disease-kinds'
  });

  return res.data;
};

export const useGetDiseaseKinds = (
  healthInfoType: HEALTH_INFO_TYPE,
  options?: UseQueryOptions<
    IGetDiseaseKinds,
    AxiosError,
    IGetDiseaseKinds,
    string[]
  >
) => {
  return useQuery(queryKeyFactory.GET_DISEASE_KINDS(), getDiseaseKinds, {
    enabled: healthInfoType === '병력'
  });
};
